import "./containerwrapper.css"; 
import CustomBreadcrumb from "../Breadcrumb/Breadcrumb";


const ContainerWrapper = ({ breadcrumbItems = [], headerRight, children, className = "" ,userRole }) => {
  return (
    <div className={`container-wrapper ${className}`}>
      <div className="container-header">
        <CustomBreadcrumb items={breadcrumbItems} userRole={userRole}  />
        <div className="header-right">
          {headerRight && headerRight} 
        </div>
      </div>
      <div className="container-content">
        {children}
      </div>
    </div>
  );
};

export default ContainerWrapper;
